import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import type { ITheme } from '@homeviews/styles'
import { Typography, Select, IconButton } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      whiteSpace: 'nowrap',
    },
    mainButtons: {
      display: 'flex',
      marginLeft: theme.spacing(1.25),
      marginRight: theme.spacing(1.25),
    },
    dropdownWrapper: {
      width: 65,
      marginLeft: theme.spacing(1.875),
    },
    pageButton: {
      margin: theme.spacing(0, 0.75),
    },
  }),
)

const DEFAULT_OPTIONS = [
  {
    label: 5,
    value: 5,
  },
  {
    label: 10,
    value: 10,
  },
  {
    label: 15,
    value: 15,
  },
  {
    label: 20,
    value: 20,
  },
  {
    label: 25,
    value: 25,
  },
  {
    label: 50,
    value: 50,
  },
]

interface IProps {
  currentPage: number
  lastPage: number
  perPage: number
  withPerPageControls?: boolean
  onPageChange: (page: number) => void
  onPerPageChange: (page: number) => void
  perPageOptions?: {
    label: number
    value: number
  }[]
}

const Pagination: React.FC<IProps> = ({
  currentPage,
  lastPage,
  perPage,
  withPerPageControls = true,
  onPageChange,
  onPerPageChange,
  perPageOptions = DEFAULT_OPTIONS,
}) => {
  const classes = useStyles()

  const handleNextPage = (): void => {
    if (currentPage === lastPage) return
    onPageChange(currentPage + 1)
  }

  const handlePrevPage = (): void => {
    if (currentPage === 1) return
    onPageChange(currentPage - 1)
  }

  const handlePerPagePage = (page: number): void => {
    onPerPageChange(page)
  }

  return (
    <div className={classes.root}>
      <Typography variant="body2">Page</Typography>
      <div className={classes.mainButtons}>
        <IconButton
          svgIcon="arrow"
          variant="outlined"
          customBgColor="white"
          rotateIcon={-180}
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        />
        <IconButton
          variant="outlined"
          customBgColor="white"
          className={classes.pageButton}
          disabled
        >
          {currentPage || 1}
        </IconButton>
        <IconButton
          svgIcon="arrow"
          variant="outlined"
          customBgColor="white"
          onClick={handleNextPage}
          disabled={currentPage === lastPage}
        />
      </div>
      {withPerPageControls && (
        <>
          <Typography variant="body2">of {lastPage}</Typography>

          <div className={classes.dropdownWrapper}>
            <Select
              options={perPageOptions}
              value={perPage}
              onChange={(option) => handlePerPagePage(option.value)}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default Pagination
